import { useCallback, useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import CTABanner from "@/components/CTABanner";
import Plans from "@/components/Plans";
import EstimateForm from "@/components/EstimateForm";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  const [content, setContent] = useState(null);
  const [prefillService, setPrefillService] = useState("");

  useEffect(() => {
    api.get("/content").then((res) => setContent(res.data)).catch(() => setContent(null));
  }, []);

  const requestEstimate = useCallback((serviceName) => {
    setPrefillService(serviceName);
    document.getElementById("estimate")?.scrollIntoView({ behavior: "smooth" });
  }, []);

  return (
    <div data-testid="home-page">
      <Navbar phone={content?.contact1_phone} />
      <main>
        <Hero phone={content?.contact1_phone} />
        <About content={content} />
        <Services onRequestEstimate={requestEstimate} overrides={content?.service_overrides || {}} />
        <Gallery />
        <CTABanner phone={content?.contact1_phone} />
        <Plans onRequestEstimate={requestEstimate} />
        <EstimateForm key={prefillService} prefillService={prefillService} />
        <Contact content={content} />
      </main>
      <Footer content={content} />
      <a
        href={`tel:${(content?.contact1_phone || "214-576-8224").replace(/[^0-9+]/g, "")}`}
        data-testid="mobile-floating-call-button"
        aria-label={`Call Somoza's Landscaping at ${content?.contact1_phone || "214-576-8224"}`}
        className="fixed bottom-4 right-4 z-50 bg-brand text-white p-4 rounded-full shadow-lg flex items-center justify-center lg:hidden hover:bg-brand-hover transition-colors"
      >
        <Phone className="w-6 h-6" aria-hidden="true" />
      </a>
    </div>
  );
}
